<template>
  <div>
    <!-- <pre>{{ newMessage }}</pre> -->
    <!-- <TextInput ref="textinput" v-show="show === 'text'" @text="onText" @send="onSend" @show="(v) => { show = v }" />
    <DrawBoard ref="drawboard" v-show="show === 'draw'" @upload="onUpload" @show="(v) => { show = v }" /> -->
  </div>
</template>

<script>
import NProgress from 'nprogress'
import { API, Status } from '@/yoteach2-gui/parts/index.js'
// import TextInput from './TextInput.vue'
// import DrawBoard from './DrawBoard.vue'
var atob = require('atob')

function dataURItoBlob (dataURI) {
  var binary = atob(dataURI.split(',')[1])
  var array = []
  for (var i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }
  return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
}

export default {
  // API,
  // components: {
  //   TextInput,
  //   DrawBoard
  // },
  props: {
    mode: {
      default () {
        return 'mobile'
      }
    },
    roomID: {
      default () {
        return this.$route.params.roomID
      }
    }
  },
  watch: {
    sending () {
      this.$emit('sending', this.sending)
    }
  },
  data () {
    let template = {
      userID: '',
      roomID: this.roomID,
      type: 'text',
      // text
      text: '',

      // img
      imgBucket: 'yoteach',
      imgUUID: '',
      imgExt: '',
      imgFileName: '',
      imgURL: '',
      imgWidth: 1,
      imgHeight: 1,

      // date
      date: new Date(),

      // goodAsk
      goodAsk: false,

      // user
      voteUpUUID: [],
      get senderUUID () {
        return Status.state.chatter.uuid
      },
      get senderName () {
        return Status.state.chatter.name
      }
    }

    return {
      sending: false,
      template,
      newMessage: JSON.parse(JSON.stringify(template))
    }
  },
  methods: {
    dataURItoBlob,
    onReply ({ reply }) {
      if (reply.type === 'text') {
        this.newMessage.replyQuote = reply.senderName + ': ' + reply.text
      } else {
        this.newMessage.replyQuote = reply.senderName + '...'
      }
      this.newMessage.parentID = reply._id
    },
    onTextInput ({ text }) {
      this.newMessage.text = text
    },
    onSendText () {
      this.newMessage.type = 'text'
      this.onSend()
    },
    async onSendLatex ({ latex }) {
      this.newMessage.type = 'latex'
      this.newMessage.text = latex
      let newMsg = await this.onSend()
      console.log(newMsg)
      return newMsg
    },
    async onSendPoll () {
      this.newMessage.type = 'poll'
      this.newMessage.isPinned = true
      let newMsg = await this.onSend()
      console.log(newMsg)
      return newMsg
    },
    async uploadBlob ({ blob, signedRequest, progress, start, end }) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.addEventListener('progress', (oEvent) => {
          if (oEvent.lengthComputable) {
            var percentComplete = oEvent.loaded / oEvent.total * 100
            progress && progress(percentComplete)
          } else {
          }
        })
        xhr.open('PUT', signedRequest)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              NProgress.done()
              resolve()
            } else {
              NProgress.done()
              reject(xhr.error)
            }
          }
          end && end()
        }
        start && start()
        NProgress.start()
        xhr.send(blob)
      })
    },
    async getResolution ({ src }) {
      return new Promise((resolve, reject) => {
        var newImage = new Image()
        newImage.onload = () => {
          resolve({
            width: newImage.width,
            height: newImage.height
          })
        }
        newImage.src = src
      })
    },
    async onSendImage ({ imageURL }) {
      let resolution = await this.getResolution({ src: imageURL })
      this.newMessage.type = 'img'
      let blob = this.dataURItoBlob(imageURL)
      // let re = /(?:\.([^.]+))?$/
      let fileMimeType = 'image/jpeg'
      let ext = 'jpg'
      let signResp = await API.signS3({ fileMimeType, ext })
      let signResultData = signResp.data
      let signedRequest = signResultData.signedRequest

      console.log(signResultData)

      this.uploadBlob({
        blob,
        signedRequest,
        start: () => {
          this.$emit('upload-progress', {
            mode: 'start',
            imageURL,
            percentage: 0
          })
        },
        end: () => {
          this.$emit('upload-progress', false)
        },
        progress: (percentage) => {
          this.$emit('upload-progress', {
            imageURL,
            mode: 'progress',
            percentage
          })
        }
      })
        .then((resp) => {
          // let data = resp.data
          this.newMessage.type = 'img'
          this.newMessage.imgBucket = signResultData.bucket
          this.newMessage.imgUUID = signResultData.uuid
          this.newMessage.imgExt = signResultData.ext
          this.newMessage.imgFileName = signResultData.fileName
          this.newMessage.imgURL = signResultData.url
          this.newMessage.imgWidth = resolution.width
          this.newMessage.imgHeight = resolution.height

          this.onSend()
        }, (err) => {
          console.log(err)
        })
    },
    async onSend () {
      if (this.sending) {
        return
      }
      this.sending = true

      this.newMessage.date = new Date()
      return API.sendMessage({
        ...this.newMessage
      }).then((cbVal) => {
        this.sending = false
        this.newMessage = JSON.parse(JSON.stringify(this.template))
        this.$emit('reset')
        return cbVal
      }, () => {
        this.sending = false
      })
    }
  }
}
</script>

<style>

</style>
